import { render } from "./BiomAtenLOV.vue?vue&type=template&id=d0a7371a"
import script from "./BiomAtenLOV.vue?vue&type=script&lang=js"
export * from "./BiomAtenLOV.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__